import {FormReducer} from 'state/reducers/form'
import {assoc} from 'ramda'

export const updateForm: FormReducer = (state, {id, payload}) => assoc(id, payload, state)
